module.exports = __webpack_public_path__ + "static/media/BE.291b4478.png";